import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

const UNSPLASH_BASE = 'https://images.unsplash.com'

const FALLBACKS: Record<string, string> = {
  home_hero:            `${UNSPLASH_BASE}/photo-1761934657948-708146148588?auto=format&fit=crop&w=1920&q=80`,
  about_team:           `${UNSPLASH_BASE}/photo-1594386479412-fa62932f4cdc?auto=format&fit=crop&w=1920&q=80`,
  pip_hero:             `${UNSPLASH_BASE}/photo-1621972600542-4cc56f0c72c0?auto=format&fit=crop&w=1920&q=80`,
  pip_mid_1:            `${UNSPLASH_BASE}/photo-1768796370577-c6e8b708b980?auto=format&fit=crop&w=1920&q=80`,
  pip_mid_2:            `${UNSPLASH_BASE}/photo-1623221647841-fbcc96e2f281?auto=format&fit=crop&w=1920&q=80`,
  pip_cta:              `${UNSPLASH_BASE}/photo-1769839271827-e7e287319dd4?auto=format&fit=crop&w=1920&q=80`,
  services_conseil:     `${UNSPLASH_BASE}/photo-1758873268180-d95d10c86588?auto=format&fit=crop&w=800&q=80`,
  services_gestion:     `${UNSPLASH_BASE}/photo-1771173479042-810085465e49?auto=format&fit=crop&w=800&q=80`,
  services_recrutement: `${UNSPLASH_BASE}/photo-1758520144437-f068ecaf0d83?auto=format&fit=crop&w=800&q=80`,
  services_support:     `${UNSPLASH_BASE}/photo-1758873268933-e0765262e58d?auto=format&fit=crop&w=800&q=80`,
}

type SiteImagesMap = Record<string, string>

const SiteImagesContext = createContext<SiteImagesMap>(FALLBACKS)

export function SiteImagesProvider({ children }: { children: ReactNode }) {
  const [images, setImages] = useState<SiteImagesMap>(FALLBACKS)

  useEffect(() => {
    fetch('/api/site-images')
      .then(r => r.ok ? r.json() : [])
      .then((slots: { slot: string; url: string | null }[]) => {
        const overrides: SiteImagesMap = {}
        for (const s of slots) {
          overrides[s.slot] = s.url ?? FALLBACKS[s.slot] ?? ''
        }
        setImages(prev => ({ ...prev, ...overrides }))
      })
      .catch(() => {/* réseau indisponible : on garde les fallbacks */})
  }, [])

  return (
    <SiteImagesContext.Provider value={images}>
      {children}
    </SiteImagesContext.Provider>
  )
}

export function useSiteImages(): SiteImagesMap {
  return useContext(SiteImagesContext)
}
